const STORAGE_KEY = "help-clic-shown-notifications";
const TTL_MS = 24 * 60 * 60 * 1000;

export const notificationFingerprint = (payload = {}) => {
  const rawData = payload.data?.data || payload.data || {};
  let data = rawData;
  if (typeof rawData === "string") {
    try {
      data = JSON.parse(rawData);
    } catch {
      data = {};
    }
  }

  if (data?.dedupeKey) return `event:${data.dedupeKey}`;

  const targetId = data?.notifiableId ?? data?.chatroomId;
  if (data?.notifiableType && targetId != null && data?.event) {
    return `event:${data.notifiableType}:${targetId}:${data.event}`;
  }

  if (payload.messageId) return `fcm:${payload.messageId}`;
  const normalizedData =
    typeof rawData === "string" ? rawData : JSON.stringify(rawData || {});
  return [
    payload.notification?.title || "",
    payload.notification?.body || "",
    normalizedData,
  ].join("|");
};

export const claimNotification = (fingerprint, now = Date.now()) => {
  if (!fingerprint) return true;
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    const active = Object.fromEntries(
      Object.entries(parsed).filter(([, timestamp]) => now - timestamp < TTL_MS),
    );
    if (active[fingerprint]) return false;
    active[fingerprint] = now;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(active));
    return true;
  } catch {
    return true;
  }
};
